export const PAGE_TITLE = "Assistive Aids";
export const PAGE_SINGLE_TITLE = "Assistive Aid";
export const LINK_URL = "aids";
export const SEARCH_TERMS = ["title", "meta_title"];
export const inputFields = {
  name: {
    type: "string",
    required: true,
    title: "Name",
    inputType: "text",
  },
  description: {
    type: "text",
    required: false,
    title: "Description",
  },
  product: {
    type: "select",
    required: false,
    title: "product",
  },
  goal: {
    type: "string",
    required: true,
    title: "Goal",
    inputType: "number",
  },
  achieved: {
    type: "string",
    required: true,
    title: "Achieved",
    inputType: "number",
  },
  featured_image: {
    type: "file",
    required: false,
    title: "Featured Image",
  },
  hide_price: {
    type: "checkbox",
    required: false,
    title: "Hide Price",
  },

  unit: {
    type: "string",
    required: false,
    title: "Unit Price",
    inputType: "number",
  },
};
export const initialValues = {
  name: "",
  description: "",
  goal: "",
  achieved: "",
  unit: "",
  product: "",
};

export const view_all_table = [
  { name: "Name", value: "name" },
  { name: "Goal", value: "goal" },
  { name: "Achieved", value: "achieved" },
  { name: "Unit Price", value: "unit" },
  { name: "Description", value: "description" },
];
